const accessLists = {
  header: {
    toolbar: {
      blackList: 'Lista negra',
      whiteList: 'Lista blanca',
    },
    buttons: {
      addNewRecord: 'Añadir nuevo registro'
    }
  },
  accessLists: 'Listas de acceso',
  showing: 'Mostrado',
  accessListsOf: 'Listas de acceso',
  noAccessListsFound: 'No se encontraron listas de acceso',
  modal: {
    category: 'Categoría',
    enterCategory: 'Introducir categoría',
    value: 'Valor',
    enterValue: 'Introducir valor',
    inputValue: 'Introducir valor',
    inputCategory: 'Introducir categoría',
    list_type: 'Tipo de lista',
    enterListType: 'Introducir tipo de lista',
    description: 'Descripción',
    enterDescription: 'Introducir descripción',
    blackList: 'Lista negra',
    whiteList: 'Lista blanca Lista',
  },
  allCategories: 'Todas las categorías',
  successAdded: 'Nuevo valor añadido'
};

export default accessLists;
